import React, { useState, useRef, useEffect } from "react";
import { useLang } from "../i18n/LanguageContext";
import { Globe, Check, ChevronDown } from "lucide-react";

const LANGS = [
  { code: "de", label: "Deutsch" },
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
];

export default function LanguageSwitcher({ dropUp = false }) {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1.5 text-sm text-[#3a4258] hover:text-[#b08d57] transition-colors"
      >
        <Globe size={16} /> {lang.toUpperCase()} <ChevronDown size={14} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className={`absolute right-0 w-40 bg-white rounded-lg border border-[#e7e2d8] shadow-xl py-1 z-50 ${dropUp ? "bottom-full mb-2" : "mt-2"}`}>
          {LANGS.map((l) => (
            <button
              key={l.code}
              onClick={() => {
                setLang(l.code);
                setOpen(false);
              }}
              className="w-full flex items-center justify-between px-4 py-2 text-sm text-[#3a4258] hover:bg-[#faf8f4] transition-colors"
            >
              {l.label} {lang === l.code && <Check size={15} className="text-[#b08d57]" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
